import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import _defineProperty from "E:/wnmp/www/www.yunkezan.com/vuecli3/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.string.iterator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { updateUrlParam, toast, showLoading, hideLoading } from '@ykz/ykz-util/base';
import databus, { Origins } from '@ykz/ykz-http/core';
var productPoster = {
  createProductPosterHandle: function createProductPosterHandle(list, idx, index) {
    var _this = this;
    console.log(this);
    var currentProduct = this[list][idx]['list'][index];
    // 产品生成海报锚点
    this.logHelpers({
      event_id: '500137',
      event_content: {
        good_id: currentProduct.goodId,
        pos: currentProduct.isActivity ? 1 : 2
      }
    });
    if (currentProduct.activityStatus == 0 || currentProduct.activityStatus == 1) {
      window.componentCenter.shareType.showBox(function (type) {
        _this.createProductPoster(list, idx, index, type);
      });
    } else {
      this.createProductPoster(list, idx, index, 0);
    }
  },
  // 生成产品页海报
  createProductPoster: function createProductPoster(list, idx, index, type) {
    var that = this,
      currentProduct = this[list][idx]['list'][index],
      shareObj = {
        shareTitle: currentProduct.goodsAlias || currentProduct.goodsName || window.comm.hotelName || '',
        descContent: window.descContent || '',
        imgUrl: currentProduct.coverPic || window.comm.hotelImg || window.comm.defaultHotelImg || '',
        type: 1,
        lineLink: currentProduct.lineLink || '',
        posterUrl: [],
        copyText: currentProduct.goodsAlias || currentProduct.goodsName || '',
        anchorData: {
          item_id: currentProduct.goodId || '',
          type: 'product',
          activity_id: currentProduct.activityId || '',
          source: 'scenic'
        }
      };

    // app加小程序分享参数
    if (this.isInApp) {
      shareObj.miniShareTitle = currentProduct.activityName || currentProduct.goodsName;
    }
    if (currentProduct["posterImgType".concat(type)] && (this.isInApp && currentProduct.miniShareImgUrl || !this.isInApp)) {
      if (this.isInApp) {
        shareObj.posterUrl = this.getAppPosters(currentProduct["posterImgType".concat(type)], currentProduct.coverPic, currentProduct.album);
        shareObj.posterImgCount = currentProduct["posterImgType".concat(type)].length;
        shareObj.miniShareImgUrl = currentProduct.miniShareImgUrl;
        this.callApp('showPoster', {
          params: shareObj
        });
      } else {
        showPosterHelper(currentProduct["posterImgType".concat(type)]);
      }
      return;
    }
    showLoading();
    currentProduct.lineLink = this.getProductPosterLink(currentProduct);
    shareObj.lineLink = currentProduct.lineLink;
    var getMethods = [this.getProductPoster(currentProduct, type)];
    if (this.isInApp) {
      // app要多加载个小程序海报图
      getMethods.push(this.getProductSharePic(currentProduct));
    }
    Promise.all(getMethods).then(function () {
      hideLoading();
      if (that.isInApp) {
        shareObj.posterUrl = that.getAppPosters(currentProduct["posterImgType".concat(type)], currentProduct.coverPic, currentProduct.album);
        shareObj.miniShareImgUrl = currentProduct.miniShareImgUrl;
        that.callApp('showPoster', {
          params: shareObj
        });
      } else {
        showPosterHelper(currentProduct["posterImgType".concat(type)]);
      }
    });
    function showPosterHelper(url) {
      window.componentCenter.multiplePosters.showBox(url);
    }
  },
  // 获取产品海报图
  getProductPoster: function getProductPoster(currentProduct, type) {
    var that = this;
    return new Promise(function (resolve, reject) {
      if (type == 1) {
        var activityComm = currentProduct.originalappSaleCommission || currentProduct.originalwechatSaleCommission || currentProduct.appSaleCommission || currentProduct.wechatSaleCommission || '';
        var routineComm = currentProduct.originalappSellComm || currentProduct.originalsellComm || currentProduct.appSellComm || currentProduct.sellComm || '';
      }
      that.getPoster({
        productId: currentProduct.goodId,
        url: currentProduct.lineLink,
        activityId: currentProduct.activityId || '',
        type: 1,
        specialType: type == 1 ? 1 : 0,
        activityComm: activityComm || '',
        routineComm: routineComm || ''
      }).then(function (url) {
        currentProduct["posterImgType".concat(type)] = url;
        resolve(url);
      }).catch(function (err) {
        console.log('获取产品海报失败', err);
        reject(err);
      });
    });
  },
  // 获取产品海报链接
  getProductPosterLink: function getProductPosterLink(currentProduct) {
    var link = this.getProductDetailsUrl(currentProduct),
      hotelId = currentProduct.hotelId;
    link = updateUrlParam(link, 'securityKey', '');
    if ((hotelId || hotelId == 0) && hotelId != 'null') {
      link = updateUrlParam(link, 'hotelId', hotelId);
    }
    if (this.promotion) {
      link = updateUrlParam(link, 'promotion', this.promotion);
    }
    return link;
  },
  // 获取产品小程序分享图
  getProductSharePic: function getProductSharePic(goods) {
    var _this2 = this;
    var that = this;
    return new Promise(function (resolve, reject) {
      if (goods.miniShareImgUrl) {
        resolve(goods.miniShareImgUrl);
        return;
      }
      that.ajaxGetSharePic({
        productId: goods.goodId,
        activityId: goods.activityId || '',
        weChatId: goods.weChatId || _this2.weChatId
      }).then(function (imgUrl) {
        goods.miniShareImgUrl = imgUrl;
        resolve(goods.miniShareImgUrl);
      }, function (err) {
        reject(err);
      });
    });
  },
  // 获取小程序分享图
  ajaxGetSharePic: function ajaxGetSharePic(data) {
    if (this.isInApp) {
      data.interfaceSource = 'app';
    }
    return new Promise(function (resolve, reject) {
      databus({
        url: '/apiv2/miniProgram/getSharePic',
        data: data,
        type: 'GET',
        success: function success(data) {
          if (data.code === 1000 && data.bcode === 100 && data.content && data.content.posterImg) {
            resolve(data.content.posterImg);
          } else {
            console.log(data.message || '获取小程序分享图有误');
            reject(data);
          }
        },
        error: function error(err) {
          console.log(err || '获取小程序分享图有误');
          reject(err);
        }
      });
    }).catch(function (err) {
      console.log(err || '获取小程序分享图有误');
    });
  },
  //获取海报图
  getPoster: function getPoster(ajaxData) {
    var that = this;

    // 大数据用
    if (that.isInApp) {
      ajaxData.url = that.addAnchorDatas(ajaxData.url, 'appPoster');
    } else {
      ajaxData.url = that.addAnchorDatas(ajaxData.url, 'poster');
    }
    return new Promise(function (resolve, reject) {
      databus({
        url: '/apiv2/marketing/getPoster',
        data: ajaxData,
        success: function success(data) {
          if (data.code === 1000 && data.bcode === 100) {
            if (data.content && data.content.posterImg) {
              var url = data.content.posterImg;
              resolve(url);
            } else {
              toast('海报图加载失败，请刷新页面重试');
              reject(data || '海报图加载失败');
            }
          } else {
            toast(data.message);
            reject(data.message || '海报图加载失败');
          }
        },
        error: function error(err) {
          toast('网络有误，请刷新重试');
          reject(err);
        }
      });
    });
  },
  addAnchorDatas: function addAnchorDatas(lineLink, name) {
    if (lineLink.indexOf('goodsDetails') > -1) {
      lineLink = updateUrlParam(lineLink, 'scenicFrom', name);
    } else {
      lineLink = updateUrlParam(lineLink, 'channel', name);
    }
    return lineLink;
  }
};
export default _objectSpread({}, productPoster); // 生成产品页海报;